import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import MaterialTree from "../tree/MaterialTree";
import MaterialTable from "../table/warehouse/material/material/MaterialTable";
import MaterialOrganizationOptionService
    from "../../../API/orders/warehouse/material/MaterialOrganizationOptionService";
import GroupMaterialService from "../../../API/orders/orders/organization/GroupMaterialService";
import GroupMaterialUtil from "../../../utils/orders/GroupMaterialUtil";

import {useLocation} from "react-router-dom";
import UserMaterialMaterialCloudService from "../../../API/material-cloud/user/UserMaterialMaterialCloudService";
import UserGroupMaterialMaterialCloudService
    from "../../../API/material-cloud/user/UserGroupMaterialMaterialCloudService";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {Paper, Switch, Typography} from "@mui/material";
import ButtonCreate from "../button/ButtonCreate";
import ButtonSelectAction from "../button/ButtonSelectAction";
import {ModalSelectAction} from "../modal/ModalSelectAction";
import {
    authorizedAdmin,
    authorizedOrganization,
} from "../../../Constants";
import MaterialService from "../../../API/material-cloud/admin/AdminMaterialMaterialCloudService";
import ModalAddSignJob from "../table/warehouse/material/material/ModalAddSignJob";
import {ModalAddMaterial} from "../modal/ModalAddMaterial";
import ModalAddJob from "../table/prodaction/jobmetricorganization/ModalAddJob";
import FormControlLabel from "@mui/material/FormControlLabel";
import {customerOrderType} from "../../../data/CustomerOrderType";
import MarginTypeOrderController from "../../../API/organization/MarginTypeOrderController";
import MarginCustomerController from "../../../API/organization/MarginCustomerController";
import MarginModal from "../../../pages/organization/storage/material/margin/MarginModal";
import MaterialCustomerOptionService from "../../../API/customer/MaterialCustomerOptionService";
import {replaceEmptyStringsOnNull} from "../../../utils/ReplaceEmptyStringsOnNull";

const MaterialPageItemModule = ({
                                    refMaterial,
                                    isSelectInEstimate,
                                    selectMaterialId,
                                    selectMaterial,
                                    typeMaterial,
                                    subTypeMaterial,
                                    modal,
                                    allMaterial,
                                    disabled,
                                    materialCloud,
                                    settings,
                                    itemId,
                                    supplierId,
                                    handleModalAlert,
                                    admin,
                                    isOrgOne,
                                    setIsPaperSelection
                                }) => {

    const pathname = useLocation().pathname
    const profile = JSON.parse(localStorage.getItem("profile"))
    const isOrganization = profile?.userRoles.some(role => authorizedOrganization.includes(role.name))
    const isAdmin = profile?.userRoles.some(role => authorizedAdmin.includes(role.name))
    const createMaterialRole = !!profile?.userRoles.find(el => el.name === "ROLE_ORGANIZATION_CREATE_MATERIAL")

    const [archive, setArchive] = useState(false)
    const [open, setOpen] = useState(false)
    const [modalAddMaterialOpen, setModalAddMaterialOpen] = useState(false)

    const [filterGroup, setFilterGroup] = useState(new Map());
    const [data, setData] = useState([]);
    const [currentData, setCurrentData] = useState([]);
    const [changeFilterGroup, setChangeFilterGroup] = useState(false);
    const [dataTree, setDataTree] = useState([]);
    const [groupMap, setGroupMap] = useState(null);

    const [rowSelection, setRowSelection] = useState([]);
    const [rowIndexSelection, setRowIndexSelection] = useState([])
    const [selectedIds, setSelectedIds] = useState([]);
    const [openModalAddSignJob, setOpenModalAddSignJob] = useState(false);
    const [groupNames, setGroupNames] = useState("");
    const [groupIds, setGroupIds] = useState([]);
    const [disabledAddMaterial, setDisabledAddMaterial] = useState(true);
    const [currentGroup, setCurrentGroup] = useState({});
    const [modalAddJob, setModalAddJob] = useState(false);
    const [deleteJob, setDeleteJob] = useState(false);
    const [marginModal, setMarginModal] = useState(false);
    const allOrderTypes = Object.entries(customerOrderType)

    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: modal ? 10 : 100,
        totalElements: 0,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setIsPaperSelection && (rowSelection.length > 0 ? setIsPaperSelection(true) : setIsPaperSelection(false))
    }, [rowSelection]);

    const [change, setChange] = useState(false)

    const [selectMaterialIdByTree, setSelectedMaterialIdByTree] = useState(null)
    const [expandedItems, setExpandedItems] = useState(['M']);

    const handleExpandedItemsChange = (event, itemIds) => {
        setExpandedItems(itemIds);
        !modal && EditLocalStoragePagesData(settings ? `${pathname}+${itemId}` : pathname, "expanded", itemIds)
    };

    const handleCalcExpanded = (group) => {
        const ids = GroupMaterialUtil.getAllParentIds(group)
        setExpandedItems([...expandedItems, ...ids]);
        !modal && EditLocalStoragePagesData(settings ? `${pathname}+${itemId}` : pathname, "expanded", [...expandedItems, ...ids])
    }

    const handleToggle = (node, tree = true) => {
        let id = parseInt(tree ? node?.id : node?.groupMaterial.id);


        const group = groupMap.get(id) || {}
        if (group !== null) {
            GroupMaterialUtil.addToFilterMapGroup(group, filterGroup)
            setFilterGroup(filterGroup);
            setChangeFilterGroup(!changeFilterGroup)
            setCurrentGroup(group)
            !modal && EditLocalStoragePagesData(settings ? `${pathname}+${itemId}` : pathname, "currentGroup", group)
        }
        if (tree) {
            setSelectedMaterialIdByTree(null)
        } else {
            setSelectedMaterialIdByTree(node.id)
            handleCalcExpanded(group)
        }
    };

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(settings ? `${pathname}+${itemId}` : pathname, "pageSize", nextState.pageSize)
        }
        if (nextState.searchData !== tableOptions.searchData) {
            EditLocalStoragePagesData(settings ? `${pathname}+${itemId}` : pathname, "searchQuery", nextState.searchData)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const archiveMaterial = JSON.parse(localStorage.getItem('archiveMaterial'))
        const pageSize = pagesData[settings ? `${pathname}+${itemId}` : pathname]?.pageSize
        const searchQuery = pagesData[settings ? `${pathname}+${itemId}` : pathname]?.searchQuery
        const newTableOptions = (pageSize && searchQuery) ? {
            ...tableOptions,
            pageSize: pageSize,
            searchData: searchQuery
        } : pageSize ? {...tableOptions, pageSize: pageSize} : searchQuery ? {
            ...tableOptions,
            searchData: searchQuery
        } : tableOptions
        setTableOptions(newTableOptions)
        const expanded = pagesData[settings ? `${pathname}+${itemId}` : pathname]?.expanded
        expanded && setExpandedItems(expanded)
        const currentGroup = pagesData[settings ? `${pathname}+${itemId}` : pathname]?.currentGroup
        currentGroup && setCurrentGroup(currentGroup)

        archiveMaterial && settings && setArchive(archiveMaterial)

    }
    const modalActions = (() => {
        const actions = [];
        actions.push({name: "Переместить в группу", type: "setGroup"})
        actions.push({name: "Добавить работу на материал", type: "add"},
            {name: "Удалить работу c материала", type: "delete"});
        actions.push({name: "Удалить", type: "deleteMaterial"})
        if (isOrganization) {
            actions.push({name: "Установить наценку на тип заказа", type: "addMarginToType"})
            actions.push({name: "Установить наценку на заказчика", type: "addMarginToCustomer"})
            actions.push({name: "Установить наценку по умолчанию", type: "setDefaultMargin"})
            actions.push({name: "Установить наименование по умолчанию", type: "setDefaultName"})
            actions.push({name: "Кроить", type: "cut"})
            actions.push({name: "Не кроить", type: "notCut"})
        }
        return actions;
    })();

    const handleCloseModalAddSignJob = () => {
        setOpenModalAddSignJob(false)
        setRowSelection([]);
        setRowIndexSelection([]);
        setSelectedIds([]);
    };

    const handleSubmitAddSignJobInMaterial = () => {
        MaterialOrganizationOptionService.addSigJobInMaterialsByMaterialGroup(selectedIds, groupIds).then(function () {
            handleCloseModalAddSignJob();
            handleModalAlert("Работы добавлены на группу", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error)
            });
    }

    const [dataSignJob, setDataSignJob] = useState([]);

    useEffect(() => {
        if (groupIds.length === 0) {
            setDisabledAddMaterial(true)
        } else {
            setDisabledAddMaterial(false)
        }
    }, [groupIds]);

    useEffect(() => {
        const api = isOrgOne ? MaterialCustomerOptionService.getAllFilter : isOrganization && !allMaterial && !materialCloud ? MaterialOrganizationOptionService.getAllFilter : UserMaterialMaterialCloudService.getAllFilter

        if (currentGroup) {
            api(currentGroup, tableOptions.pageIndex, tableOptions.pageSize,
                null, typeMaterial, subTypeMaterial, tableOptions.searchData, archive, supplierId).then(function (response) {
                let data = response.data;
                setCurrentData(data.content)
                setTableOptions((prev) => ({...prev, totalElements: data.total}))
            })
                .catch(function (error) {
                    handleModalAlert(error)
                });
        }
    }, [change, currentGroup, tableOptions.searchData, tableOptions.pageIndex, tableOptions.pageSize, archive]);

    useEffect(() => {
        !modal && getStartPageSize()
        const api = isOrgOne ? MaterialCustomerOptionService.getGroup : isOrganization && !allMaterial && !materialCloud ? GroupMaterialService.getAllByOrganization : UserGroupMaterialMaterialCloudService.getAll

        api(typeMaterial, subTypeMaterial).then((response) => {
            const buildTreeGroups = GroupMaterialUtil.buildTreeGroups(response.data);
            setDataTree(buildTreeGroups);
            const groupMap = new Map();
            GroupMaterialUtil.addToMap(buildTreeGroups, groupMap)
            setGroupMap(groupMap);
        }).catch(function (error) {
            handleModalAlert(error)
        });
    }, []);

    const handleChange = () => {
        setArchive(!archive)
        setRowSelection([]);
        localStorage.setItem("archiveMaterial", JSON.stringify(!archive))
    }

    const handleSelectAction = (action, data, handleCancel) => {
        if (action === "add") {
            setModalAddJob(true)
            setOpen(false)
        } else if (action === "delete") {
            setModalAddJob(true)
            setDeleteJob(true)
            setOpen(false)
        } else if (action === "addMarginToType" || action === "addMarginToCustomer") {
            setOpen(false)
            setMarginModal(action)
        } else if (action === "setDefaultMargin") {
            setLoading(true)
            MaterialOrganizationOptionService.setDefaultMargin(data, {"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        } else if (action === "setGroup") {
            setLoading(true)
            const api = admin ? MaterialService : MaterialOrganizationOptionService
            api.setGroup(data, {"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                setChange(prev => !prev)
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        } else if (action === "cut") {
            setLoading(true)
            MaterialOrganizationOptionService.setCut(true, {"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        } else if (action === "notCut") {
            setLoading(true)
            MaterialOrganizationOptionService.setCut(false, {"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        } else if (action === "setDefaultName") {
            setLoading(true)
            MaterialOrganizationOptionService.setDefaultName({"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                setChange(prev => !prev)
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        } else if (action === "deleteMaterial") {
            setLoading(true)
            const api = admin ? MaterialService : MaterialOrganizationOptionService
            api.deleteMaterial({"ids": rowSelection}).then(() => {
                setRowSelection([])
                handleCancel()
                setChange(prev => !prev)
                handleModalAlert("Данные изменены", 'success')
            }).catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))
        }
    }
    const handleOpenModalAddSignJob = () => {
        setOpenModalAddSignJob(true)
    };
    const addMarginHandle = (data) => {
        setLoading(true)
        const api = marginModal === "addMarginToType" ? MarginTypeOrderController : MarginCustomerController
        api.byIds(data, rowSelection).then(function (response) {
            setMarginModal("")
            setRowSelection([])
            handleModalAlert("Наценка добавлена", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false))
    }
    const handleSubmitAddJob = (ids, addedData, orderJobType) => {
        setLoading(true)
        if (admin) {
            const api = deleteJob ? MaterialService.deleteJobMetricByMaterialIds : MaterialService.addJobMetricByMaterialIds
            api({
                "firstIds": ids,
                "secondIds": rowSelection
            }, orderJobType).then(function (response) {
                setModalAddJob(false)
                setDeleteJob(false)
                setRowSelection([])
                handleModalAlert(deleteJob ? "Работа удалена с группы" : "Работа добавлена на группу", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        } else {
            const api = deleteJob ? MaterialOrganizationOptionService.deleteJobMetricByMaterialIds : MaterialOrganizationOptionService.addJobMetricByMaterialIds
            api({
                "firstIds": ids,
                "secondIds": rowSelection
            }).then(function (response) {
                setModalAddJob(false)
                setDeleteJob(false)
                handleModalAlert(deleteJob ? "Работа удалена с группы" : "Работа добавлена на группу", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }
    }
    const handleAddMaterial = (byMaterial, queryStringData, data, handleClose) => {
        setLoading(true)
        const api = admin ? MaterialService.save : byMaterial ? MaterialOrganizationOptionService.saveByMaterial : MaterialOrganizationOptionService.save
        api(queryStringData, replaceEmptyStringsOnNull(data)).then((response) => {
            setChange(prev => !prev)
            handleModalAlert("Данные добавлены", 'success')
            handleClose()
        })
            .catch(function (error) {
                handleModalAlert(error)
            })
            .finally(() => setLoading(false))
    }

    return (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: "column",
                maxWidth: "2000px",
            }}>
                {!modal && <Box sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "8px"}}>
                    <Typography sx={{fontSize: "24px", fontWeight: 700}}>Материалы</Typography>
                    <Box sx={{display: 'flex', gap: "8px"}}>
                        {settings && <FormControlLabel
                            control={<Switch checked={archive} onChange={handleChange} name="archive"/>}
                            label="Архив материалов"
                        />}
                        {(settings && (isAdmin || createMaterialRole)) && <ButtonCreate
                            onClick={() => setModalAddMaterialOpen(true)}
                            variant="contained"
                            text={"Создать материал"}
                        />}
                    </Box>
                </Box>}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: "16px"
                }}>
                    <Box sx={{
                        flexBasis: '50%',
                        maxWidth: '500px',
                        paddingTop: Object.keys(rowSelection).length !== 0 ? "71px" : "49px"
                    }}>
                        <MaterialTree
                            key={"Материалы"}
                            name={"Материалы"}
                            data={dataTree}
                            currentGroup={currentGroup}
                            setCurrentGroup={setCurrentGroup}
                            handleToggle={handleToggle}
                            expandedItems={expandedItems}
                            handleExpandedItemsChange={handleExpandedItemsChange}
                            height={modal ? "inherit" : rowSelection.length > 0 ? `calc(100vh - 420px)` : `calc(100vh - 320px)`}
                        />
                    </Box>
                    <Box sx={{
                        flexBasis: 'auto',
                        overflow: 'auto',
                        borderTopLeftRadius: '3px',
                        borderTopRightRadius: '3px'
                    }}>
                        <MaterialTable
                            currentData={currentData}
                            refMaterial={refMaterial}
                            isSelectInEstimate={isSelectInEstimate}
                            rowSelection={rowSelection}
                            setRowSelection={setRowSelection}
                            rowIndexSelection={rowIndexSelection}
                            selectMaterialId={selectMaterialId}
                            selectMaterial={selectMaterial}
                            tableOptionsHandle={tableOptionsHandle}
                            tableOptions={tableOptions}
                            modal={modal}
                            allMaterial={allMaterial}
                            enableRowSelection={settings}
                            disabled={disabled}
                            settings={settings}
                            sx={{
                                borderBottomLeftRadius: '0px',
                                borderBottomRightRadius: '0px',
                                maxWidth: '100%',
                            }}
                            handleToggle={handleToggle}
                            selectMaterialIdByTree={selectMaterialIdByTree}
                        />
                    </Box>
                </Box>
            </Box>
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
                dataTree={dataTree}
                loading={loading}
            />
            {modalAddMaterialOpen && <ModalAddMaterial
                open={modalAddMaterialOpen}
                onClose={() => setModalAddMaterialOpen(false)}
                title={"Добавить материал"}
                onSubmit={handleAddMaterial}
                filterGroup={filterGroup}
                dataTree={dataTree}
                groupMap={groupMap}
                setFilterGroup={setFilterGroup}
                setChangeFilterGroup={setChangeFilterGroup}
                changeFilterGroup={changeFilterGroup}
                admin={admin}
                loading={loading}
            />}
            <ModalAddSignJob
                title={"Добавить работы на группу " + groupNames}
                open={openModalAddSignJob}
                handleClose={handleCloseModalAddSignJob}
                handleSubmit={handleSubmitAddSignJobInMaterial}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
                rowIndexSelection={rowIndexSelection}
                setRowIndexSelection={setRowIndexSelection}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                data={dataSignJob}
                setData={setDataSignJob}
                change={change}
                setChange={setChange}
            />
            {modalAddJob && <ModalAddJob
                open={modalAddJob}
                onClose={() => setModalAddJob(false)}
                onSubmit={handleSubmitAddJob}
                handleModalAlert={handleModalAlert}
                group={true}
                deleteJob={deleteJob}
                admin={admin}
                baseCurrency={profile?.baseCurAbbreviation}
                alternativeCurrency={profile?.alternativeCurAbbreviation}
                loading={loading}
            />}
            {marginModal && <MarginModal
                title={marginModal === "addMarginToType" ? "Добавить наценку на тип заказа" : "Добавить наценку на заказчика"}
                marginModal={marginModal} onClose={() => setMarginModal("")}
                handleSubmit={addMarginHandle}
                initValue={{margin: "", orderType: allOrderTypes[0][0], current: true}}
                allOrderTypes={allOrderTypes}
                loading={loading}
            />}
        </>
    );
};


export default MaterialPageItemModule;
